import React, { useState, useEffect, useContext } from 'react';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { useDispatch, useSelector } from 'react-redux';
import { debounce } from 'lodash';

import { getImpersonate } from '../../../../common/services/http/userService';
import { RootState } from '../../../../redux/store';
import { IMPERSONATE_ON, SET_IMPERSONATE_ID, SET_IMPERSONATE_NAME } from '../../../../redux/types';
import Main from '../../../layout/main/main';
import Icon from '../../../ui/icon/icon';
import setImpersonationToLS from '../../../../common/utility/setImpersonationToLS';

import './impersonate.scss';
import useTranslate from '../../../../common/hooks/useTranslate';
import FilterCtx from '../../../../context/filterContext/filterCtx';
import OutletLoader from '../../../ui/loaders/outletLoader/outletLoader';
import useForceUpdate from '../../../../common/hooks/useForceUpdate';

const SelectCell = (props: any) => {
  const [checked, setChecked] = useState(false);

  const dispatch = useDispatch();
  const impersonate = useSelector((state: RootState) => state.impersonate);
  const filterCtx: any = useContext(FilterCtx);

  const clickOnHandler = () => {
    dispatch({ type: IMPERSONATE_ON });
    dispatch({ type: SET_IMPERSONATE_ID, value: props.dataItem.subjectId });
    dispatch({ type: SET_IMPERSONATE_NAME, value: props.dataItem.name });
    setImpersonationToLS(true, props.dataItem.subjectId, props.dataItem.name);
    setChecked(true);
    filterCtx.clearAllFilters();
    useForceUpdate();
  };

  const clickOffHandler = () => {
    setChecked(false);
  };

  useEffect(() => {
    impersonate.impersonateId === props.dataItem.subjectId ? setChecked(true) : setChecked(false);
  }, [impersonate]);

  return (
    <td className="impersonate-select-cell">
      {checked ? <Icon name="fas fa-circle-dot" onClick={clickOffHandler} /> : <Icon name="far fa-circle" onClick={clickOnHandler} />}
    </td>
  );
};

const Impersonate: React.FC = () => {
  const { t } = useTranslate();
  const [impersonateList, setImpersonateList] = useState([]);
  const [impersonatorName, setImpersonatorName] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    impersonatorName ? getImpersonate(impersonatorName).then((r) => setImpersonateList(r.data)) : getImpersonate().then((r) => setImpersonateList(r.data));
    setLoading(false);
  }, [impersonatorName]);

  const handleInputChange = debounce((e) => {
    setImpersonatorName(e.target.value);
  }, 200);
  // @ts-ignore
  return (
    <Main className="impersonalisation-wrapper" title={t('IMPERSONATE.PAGE_TITLE')} subtitle={t('IMPERSONATE.PAGE_SUBTITLE')}>
      <div className={'search-user-wrapper'}>
        <input className="search-input" type="search" placeholder={t('IMPERSONATE.PLACEHOLDER_SEARCH')} onChange={handleInputChange} />
      </div>

      {loading ? (
        <div className="loader-wrapper">
          <OutletLoader />
        </div>
      ) : (
        <Grid data={impersonateList} className="impersonate-grid">
          <GridColumn field="subjectId" title={t('IMPERSONATE.COLUMN_SELECT')} cell={SelectCell} width={150} />
          <GridColumn field="name" title={t('IMPERSONATE.COLUMN_NAME')} />
          <GridColumn field="userName" title={t('IMPERSONATE.COLUMN_USERNAME')} />
        </Grid>
      )}
    </Main>
  );
};

export default Impersonate;
